/**
 * You should now be able to simply use the jvSelect2 directive and associated attributes to configure the Select2.
 * The old jvSelectfilter directive should be maintained here for backwards-compatibility until we replace it.
 *
 * usage:   <div
 *              jv-Select2="jv-select2id" // Unique name
 *              jv-Select2-placeholder='Generic placeholder' // Initial placeholder value
 *              jv-Select2-allow-clear='true' // Allows the users to clear the options
 *              jv-Select2-data='array of objects' // Example: { text: '00:15', id: '0015Minute', value: 15} // id must be string, the data that you want to use as values to choose from
 *              jv-Select2-value='<some scope-level value object>'
 *              jv-select2-Ids or jv-select2-Objects
 *              jv-select2-shared-model="true" // Allows for the use of shared ng-model values
 *              jv-select2-default-value="<ID value that you want to be loaded initially>"
 *              ng-model="object"> // The object where you want to store the data
 *          </div>
 *
 * You must define either jv-Select2-Ids OR jv-Select2-Objects, not both and not neither
 * Even handles late-binding of data (like if it must be populated from results of an AJAX call).
 *
 */

angular.module("JV.Core.Directives", ['jv-NotificationBar'])
    .value("Select2Constants", {
        "DataSource" : "jvSelect2Data",
        "TextField" : "jvSelect2TextField",
        "IdField" : "jvSelect2IdField",
        "Placeholder" : "jvSelect2Placeholder",
        "AllowClear" : "jvSelect2AllowClear",
        "HideSearch" : "jvSelect2HideSearch",
        "Disable": "jvSelect2Disable"
    })
    .factory("getDataSource", ["Select2Constants", function(Select2) {
        return function(scope, attributes) {
            return scope.$eval(attributes[Select2.DataSource]) || [];
        }
    }])
    .factory("getModel", [function() {
        return function(scope, attributes) {
            return scope.$eval(attributes.ngModel);
        }
    }])
    .factory("returnObjectFromObjectAndArray", function($filter) {
        return function(objectValue, arrayToFilter, placeholderObj) {
            var filteredList = $filter('filter')(arrayToFilter || [], function(arrEl) {
                var match = true;
                angular.forEach(objectValue, function(val, key) {
                    if(arrEl[key] !== val) {
                        match = false;
                    }
                });
                return match;
            });
            if (filteredList.length !== 1 && angular.isDefined(placeholderObj)) {
                return placeholderObj;
            } else {
                return filteredList[0];
            }
        }
    })
    .factory("returnObjectFromTextAndArray", ["returnObjectFromObjectAndArray", function(searchArray) {
            return function(textValue, textField, arrayToSearch, placeholderObj) {
                var obj = {};
                obj[textField] = textValue;
                return searchArray(obj, arrayToSearch, placeholderObj);
            }
    }])
    .factory("findTextField", ['Select2Constants', function(Select2) {
            return function(attr) {
                return attr[Select2.TextField] || "text";
            }
    }])
    .factory("findIdField", ['Select2Constants', function(Select2) {
            return function(attr) {
                return attr[Select2.IdField] || "id";
            }
    }])
    .factory("buildPlaceholderObj", ['Select2Constants', "findIdField", "findTextField", function(Select2, id, text) {
            return function(attr, elseObj) {
                var obj = {};
                if(angular.isDefined(attr[Select2.Placeholder])) {
                    obj[id(attr)] = "";
                    obj[text(attr)] = attr[Select2.Placeholder];
                    return obj;
                } else {
                    return elseObj; // COULD BE UNDEFINED!!!
                }
            }
    }])
    .directive("jvSelect2", ["Select2Constants", "returnObjectFromTextAndArray", "$timeout", function(Select2, searchFromText, $timeout) {
            return {
                restrict: 'A',
                require: ['ngModel', '?jvSelect2Ids', '?jvSelect2Objects'],
                link: function(scope, element, attr, requires) {
                    var ngModel = requires[0];
                    var baseCtrl = requires[1] || requires[2];
                    var sharedModel = !!attr.jvSelect2SharedModel || false;
                    /*
                        attr.jvSelect2CanClear
                        This attribute is used to clear all options form the select2 dropdown. By default its set to false
                        meaning when user hits 'x' on a non-ajax select2 it defaults back to the last selected value.
                        If on clicking 'x' you want to default back to the text 'Select an option' set an attribute
                        jv-select2-can-clear="true" in the select2 declartion. NV
                    */
                    var canClearOptions = false;
                    if(attr.jvSelect2CanClear==='true'){
                        canClearOptions = true;
                    }
                    if(angular.isUndefined(baseCtrl) || (requires[1] && requires[2])) {
                        throw new SyntaxError("You must define either jv-Select2-Ids OR jv-Select2-Objects, not both and not neither");
                    }
                    var hiddenField = angular.element("<input style='"+ attr["style"] +"' type=\"hidden\" id=\"" + attr.jvSelect2 + "\" />"),
                        _text = baseCtrl._text,
                        _id = baseCtrl._id,
                    getId = function(obj) {
                        return obj[_id];
                    },
                    getData = function(obj) {
                        var paths = _text.split('.')
                            , current = obj
                            , i;

                        for (i = 0; i < paths.length; ++i) {
                          if (current[paths[i]] == undefined) {
                            return undefined;
                          } else {
                            current = current[paths[i]];
                          }
                        }
                        return current;
                    };

                    element.append(hiddenField);

                    ngModel.$render = function() {
                        $(hiddenField).select2("data", ngModel.$viewValue);
                        if(ngModel.$viewValue === baseCtrl._placeholder) {
                            ngModel.$setViewValue(baseCtrl._placeholder);
                        }
                    };

                    var options = window._jvPluginDefaults ? angular.copy(window._jvPluginDefaults.select2) : {};
                    function ifDefinedThenOptionize(hash, value) {
                        if(angular.isDefined(value)) {
                            options[hash] = value;
                        }
                    }
                    ifDefinedThenOptionize("placeholder", attr[Select2.Placeholder]);
                    ifDefinedThenOptionize("allowClear", attr[Select2.AllowClear] !== "false"); //property has to be set as boolean than string
                    ifDefinedThenOptionize("formatSelection", getData);
                    ifDefinedThenOptionize("formatResult", getData);
                    ifDefinedThenOptionize("minimumResultsForSearch", attr[Select2.HideSearch] ? -1 : 0);
                    ifDefinedThenOptionize("id", getId);
                    ifDefinedThenOptionize("data", {results: baseCtrl._dataSource, text: _text});
                    //@i18N: extend Select2 configuration to support group {Parent-child}  rendering
                    if(attr.jvSelect2TemplateGroup){
                        angular.extend(options, scope.select2Options);
                    }
                    options.initSelection = function(elem, callback) {
                        var x = {};
                        x[_text] = ngModel.$viewValue[_text];
                        callback(x);
                    };

                    if(attr.jvSelect2DropdownCss){
                        options.dropdownCssClass = attr.jvSelect2DropdownCss;
                        window._jvPluginDefaults.select2.dropdownCssClass = attr.class + ' ' + attr.jvSelect2DropdownCss;
                    }

                    if(attr.jvSelect2FormatSelection){
                        options.formatSelection = scope.$eval(attr.jvSelect2FormatSelection);
                    }

                    $(hiddenField).select2(options).on('change', function(e) {
                        if(!scope.$$phase){
                            scope.$apply(function() {
                                var obj;
                                if(e.target.value){
                                    obj = searchFromText(e.target.value, _id, baseCtrl._dataSource, baseCtrl._placeholder);
                                }else if(canClearOptions){
                                    e.target.value  = i18n['SELECT_AN_OPTION'] || 'Select an option';
                                    baseCtrl._placeholder = {'label': i18n['SELECT_AN_OPTION'] || 'Select an option'};
                                    obj = searchFromText(e.target.value, _id, baseCtrl._dataSource, baseCtrl._placeholder);
                                    $(hiddenField).select2("data",{name: i18n['SELECT_AN_OPTION'] || 'Select an option',label: i18n['SELECT_AN_OPTION'] || 'Select an option'});
                                }
                                ngModel.$setViewValue(obj);
                            });
                        }
                    });

                    // Watch the data object, and update the directive if it has changed
                    //VA: Updated, beause of below code the drop down were removing the placeholder for the select2, now first checking for the value being defined and then making the change.
                    if (sharedModel) {
                        scope.$watch(attr.jvSelect2Data, function(newVal, oldVal){
                            if(angular.isDefined(newVal)){
                                window._jvPluginDefaults.select2["minimumResultsForSearch"] = 0;
                                if(attr[Select2.HideSearch]){
                                    window._jvPluginDefaults.select2["minimumResultsForSearch"] = -1;
                                }
                                $(hiddenField).select2(angular.extend({data: {results: newVal}}, window._jvPluginDefaults.select2));
                            }
                        });
                    }

                    scope.$watch(attr[Select2.Disable], function(newValue, oldValue){
                        if(newValue==true){
                            $(hiddenField).select2("enable", false);
                        }else{
                            $(hiddenField).select2("enable", true);
                        }
                    })
                }
            };
        }])
    .directive("jvSelect2Objects", ["Select2Constants", "findIdField", "findTextField", "buildPlaceholderObj", "returnObjectFromObjectAndArray", "getDataSource", function(Select2, id, text, placeholder, searchArray, getDataSource) {
            return {
                require:["ngModel", "jvSelect2Objects"],
                controller: "jvSelect2ReturnTypeCtrl",
                link: function(s,e,a,ctrls) {
                    var ngModel = ctrls[0];
                    var baseCtrl = ctrls[1];

                    ngModel.$formatters.push(function(objValue) {
                        return objValue || baseCtrl._placeholder;
                    });


                    ngModel.$parsers.push(function(objValue) {
                        return searchArray(objValue, baseCtrl._dataSource, baseCtrl._placeholder);
                    })
                }
            }
        }])
    .directive("jvSelect2Ids", ["Select2Constants", "findIdField", "findTextField", "buildPlaceholderObj", "returnObjectFromObjectAndArray", function(Select2, id, text, placeholder, searchArray) {
            return {
                require:["ngModel", "jvSelect2Ids"],
                controller: "jvSelect2ReturnTypeCtrl",
                link: function(s,e,a,ctrls) {
                    var ngModel = ctrls[0];
                    var baseCtrl = ctrls[1];

                    // TO $VIEWVALUE
                    ngModel.$formatters.push(function(idValue) {
                        var searchObj = {};
                        searchObj[baseCtrl._id] = idValue;
                        var returnObj = searchArray(searchObj, baseCtrl._dataSource, baseCtrl._placeholder);
                        return returnObj;
                    });

                    // TO $MODELVALUE
                    ngModel.$parsers.push(function(objValue) {
                        return searchArray(objValue, baseCtrl._dataSource, baseCtrl._placeholder)[baseCtrl._id];
                    });
                }
            }
        }])
    .directive("jvProcessing", function() {
        return {
            compile: function(tElement, tAttrs) {
                var processingWindow = angular.element("<div class='jqDnR jqmWindow'></div>");
                tElement.prepend(processingWindow);
                var content = angular.element("<center><img src='/__assets__/images/ajax-loader.gif' style='padding-top: 50%' /></center>");
                $(processingWindow).html(content);
                $(processingWindow).css("display", "none");
                processingWindow.css({"top":"","left":""});
                $.jqm.params.modal = true;
                $(processingWindow).jqm( );       // initialization.

                return function(scope, element, attrs) {
                    scope.$watch('showProcessingWindow', function(val) {
                    if(val) {
                        $(processingWindow).jqmShow();
                        $(processingWindow).css("display", "block");
                    } else {
                        $(processingWindow).jqmHide();
                    }
                });
                }
            }
            };

        })
    /**
     * jv:warnDirty directive is used to show a confirmation message when the user
     * navigates away from the page and the form is dirty.
     *
     * @param [message] {string} Optional message to show. Default i18n.NAV_AWAY_WARNING_MESSAGE
     **/
    .directive('jvWarndirty', ['$window', function(window) {
        return {
            require: 'form',
            link: function(scope, elm, attrs, ctrl) {
                var message = attrs.jvWarndirty || ( (window.i18n) ? window.i18n.NAV_AWAY_WARNING_MESSAGE : '' ),
                dirtyCheck = (function(ctrl, message) {
                    return function(){
                        if (ctrl.$dirty) {
                            return message;
                        }
                    };
                })(ctrl, message);

                // can be removed if check is no longer needed
                ctrl.removeWarnDirty = function() {
                    $(window).off('beforeunload', dirtyCheck);
                };

                $(window).on('beforeunload', dirtyCheck);
            }
        };
    }])
    /**
     * jvBodyscroll directive is used to add a class to the body tab when ever a modal is open
     * This class adds a overflow hidden property which disables the scrolling on the body when a
     * modal is open.
     *
     * Additional to this, it also closes dropdown forcefully.
     *
     * @param condition to show the modal
     **/
    .directive('jvBodyscroll', ['$document', function($document) {
        return {
        	link: function(scope, elm, attrs) {
        		/**
        		scope.$watch(attrs.jvBodyscroll, function(newVal, oldVal){
        			if(newVal){
                        //This is when the modal is visible
                        var element  = $document.children('html').children('body');
                        element.addClass('disableBodyScroll');
                    }else{
                        var element  = $document.children('html').children('body');
                        element.removeClass('disableBodyScroll');
                        /*
                         * Select2 dropdown is open inside a modal doesn't collapse when the modal is closed.Force the select2 dropdown to close.
                         * This is an open bug with select2. https://github.com/ivaynberg/wicket-select2/issues/13
                         * /
                        if(newVal === false && $('.select2-drop-active').length > 0){
                            $('.select2-drop-active').select2('close');
                        }
                    }
                 });
				*/
            }
        };
    }])
    .directive('jvSortbyMenu', [function(){
        return{
            restrict: 'A',
            scope: {
                sortOptions: '=',
                sortTitle: '@',
                sortSelect: '=',
                sortSelected: '=',
                sortToggle:'='
            },
            replace: true,
            template: '<span class="dropDownMenu" ng-click="sortToggle=!sortToggle">'+
                        '{{sortTitle}}:' +
                        '<a class="ellipsis" title="{{sortSelected}}">{{sortSelected}}</a>' +
                        '<ul ng-cloak ng-show="sortToggle" class="ng-cloak jv-sortPanel">' +
                            '<li ng-repeat="(index,object) in sortOptions" ng-click="sortSelect(index);"><a href="javascript: void(0)">{{object.text}}</a></li>' +
                        '</ul>' +
                    '</span>'
        };
    }])
    .directive('jvDropdownError', ['$document','$timeout', function ($document, $timeout) {
        return {
            restrict: 'A',
            compile: function(elem, attrs){
                elem.parent().append("<div class='dropMenuError' id='"+ attrs.jvDropdownError +"''>" + attrs.jvDropdownErrorMessage + "</div>");
                var docElement = $document;

                return function (scope, elem, attrs) {
                    scope.$watch(attrs.jvDropdownError, function(newVal,oldVal) {
                        var dropMenuElements = $('#' + attrs.jvDropdownError);
                        if(newVal){
                            dropMenuElements.show();
                            //binding click on timeout to avoid current click event
                            $timeout(function(){
                                if (jQuery.fn.on && jQuery.fn.off) {
                                    docElement.on('click', function handleError(){
                                        docElement.off('click', handleError);
                                        dropMenuElements.hide();
                                        scope[attrs.jvDropdownError] = !scope[attrs.jvDropdownError];
                                    });
                                } else {
                                    docElement.bind('click', function handleError(){
                                        docElement.unbind('click', handleError);
                                        dropMenuElements.hide();
                                        scope[attrs.jvDropdownError] = !scope[attrs.jvDropdownError];
                                    });
                                }
                            },100);
                        }else{
                            dropMenuElements.hide();
                        }
                    });
                };
            }
        };
    }])
    .directive("switch",function(){
    	return{
    		restrict:"AE",
    		replace:!0,transclude:!0,template:function(n,e)
    		{var s="";
    		return s+="<span",s+=' class="switch'+(e.class?" "+e.class:"")+'"',s+=e.ngModel?' ng-click="'+e.ngModel+"=!"+e.ngModel+(e.ngChange?"; "+e.ngChange+'()"':'"'):"",s+=' ng-class="{ checked:'+e.ngModel+' }"',s+=">",s+="<small></small>",s+='<input type="checkbox"',s+=e.id?' id="'+e.id+'"':"",s+=e.name?' name="'+e.name+'"':"",s+=e.ngModel?' ng-model="'+e.ngModel+'"':"",s+=' style="display:none !important" />',s+='<span class="switch-text">',s+=e.on?'<span class="on">'+e.on+"</span>":"",s+=e.off?'<span class="off">'+e.off+"</span>":" ",s+="</span>"}}
    	})
    .controller("jvSelect2ReturnTypeCtrl", ["$scope", "$attrs", "findIdField", "findTextField", "getDataSource", "$parse", "buildPlaceholderObj", "Select2Constants", function($scope,$attrs, id, text, getDataSource, $parse, placeholder, Select2) {
        var self = this;
        var shallowCopy = function(src) {
            var returnArr = [],
                length = src.length,
                i = 0;

            for( ; i < length; i++) {
                returnArr[i] = src[i];
            }

            return returnArr;
        };

        self._dataSource = shallowCopy(getDataSource($scope, $attrs));
        self._id = id($attrs);
        self._text = text($attrs);
        self._placeholder = placeholder($attrs, self._dataSource[0] || {});
        self._hack = angular.noop;


        $scope.$watch($attrs[Select2.DataSource], function(newVal) {
            var myVal = shallowCopy(newVal || []);
            while(self._dataSource.length > 0) {
                self._dataSource.pop();
            }
            while(myVal.length > 0) {
                self._dataSource.push(myVal.shift());
            }
            self._placeholder = placeholder($attrs, self._dataSource[0]);
        });
    }]);

angular.module("jv-NotificationBar", [])
    .value("startingAnimationTime", 300)
    .value("endingAnimationTime", 300)
    .service("NotificationBar", function() {
        var domElement = {};

        this.RegisterDOM = function(postingFunction, notifyName) {
            domElement[notifyName] = postingFunction;
        };

        this.PostMessage = function(message, notifyName, timeToLinger, cssToApply) {
            (domElement[notifyName] || angular.noop)(message, timeToLinger, cssToApply);
            if(angular.isUndefined(domElement[notifyName])) {
                throw new Error("Attempted to post message to nonexistent (yet) notifyName: " + notifyName);
            }
        };
    })
    .service("5SecondNotificationBar", function(NotificationBar) {
        this.PostMessage = function(message, notifyName, cssToApply) {
            NotificationBar.PostMessage(message, notifyName, 5000, cssToApply);
        };
    })
    .service("3SecondNotificationBar", function(NotificationBar) {
        this.PostMessage = function(message, notifyName, cssToApply) {
            NotificationBar.PostMessage(message, notifyName, 3000, cssToApply);
        };
    })
    .service("20SecondNotificationBar", function(NotificationBar) {
        this.PostMessage = function(message, notifyName, cssToApply) {
            NotificationBar.PostMessage(message, notifyName, 20000, cssToApply);
        };
    })
    .service("1SecondNotificationBar", function(NotificationBar) {
        this.PostMessage = function(message, notifyName, cssToApply) {
            NotificationBar.PostMessage(message, notifyName, 1000, cssToApply);
        };
    })
    .service("GenericNotificationBar", function(NotificationBar) {
        this.PostMessage = function(message, notifyName) {
            NotificationBar.PostMessage(message, notifyName, 0, "");
        };
    })
    .value("defaultNotifyName", "NotificationBar")
    .directive("notificationBar", function($rootScope, $compile, startingAnimationTime, NotificationBar, defaultNotifyName) {
        return {
            restrict:"C",
            controller: function($scope, $element, $attrs) {
                function addMessage(message, timeToLinger, cssToApply) {
                    cssToApply = cssToApply || "";
                    timeToLinger = startingAnimationTime + timeToLinger;
                    var template = angular.element(
                        "<div class=\"notification-message "+cssToApply+"\" time=\""+timeToLinger+"\">"+message+"</div>");
                    var newScope = $rootScope.$new();
                    $element.append($compile(template)(newScope));
                }
                NotificationBar.RegisterDOM(addMessage, $attrs.id || defaultNotifyName);
            }
        };
    })
    .directive("informationBar", function(startingAnimationTime, NotificationBar, defaultNotifyName, $timeout, $document, $window) {
        return {
            restrict:"C",
            controller: function($scope, $element, $attrs) {
                var _heightToSwitch = 30;
                var newEl = angular.element("<div class=\"informationMessage\"></div>")
                    , _isFixed = ($window.scrollTop > _heightToSwitch);
                $element.append(newEl);
                function scrollHandler(ev) {
                    if($window.scrollY <= _heightToSwitch && _isFixed) {
                        // transition from Fixed to Absolute (docked)
                        newEl.css("margin-top", 55);
                        $element.css("height", 80);
                        $element.css("position", "absolute");
                        _isFixed = false;
                    } else if ($window.scrollY > _heightToSwitch && !_isFixed){
                        // transition from Absolute to Fixed (floating)
                        newEl.css("margin-top", "");
                        $element.css("height", "");
                        $element.css('position', "");
                        _isFixed = true;
                    }
                }
                function addMessage(message, timeToLinger, cssToApply) {
                    cssToApply = cssToApply || "";
                    timeToLinger = startingAnimationTime + timeToLinger;
                    newEl.text(message);
                    if (jQuery.fn.on) {
                        $document.on("scroll", scrollHandler);
                      } else {
                        $document.bind("scroll", scrollHandler);
                      }
                    $element.css("bottom", 0);
                    $element.addClass(cssToApply);
                    scrollHandler();

                    $timeout(function() {
                        $element.css("bottom", '');
                        $element.css("height", '');
                        $element.css("position", "");
                        newEl.css("margin-top", "");
                        if (jQuery.fn.off) {
                            $document.off("scroll", scrollHandler);
                          } else {
                            $document.unbind("scroll", scrollHandler);
                          }
                        if(cssToApply) {
                            $timeout(function() {
                                $element.removeClass(cssToApply);
                            }, 1000);
                        }
                    }, timeToLinger);
                }
                NotificationBar.RegisterDOM(addMessage, $attrs.id || defaultNotifyName);
            }
        };
    })
    .directive("notificationMessage", function($timeout, endingAnimationTime) {
        return {
            restrict:"C",
            transclude:true,
            template: "<a href=\"javascript:void(0)\" ng-click=\"close()\">x</a><div ng-transclude></div>",
            link: function(scope, el, attr) {
                var promiseToEnd,
                    promiseToDestroy;
                // Ugly hack to get css styling to be interpreted correctly by browser.
                // The CSS doesn't seem to be interpreted until after the linking function, so adding
                // the "show" class within this JS event loop causes the "show"'s opacity rule to override
                // the "base" CSS class, and we don't get the snazzy fade-in effect.
                //Blech!
                $timeout(function() {
                    el.addClass("show");
                }, 1);
                scope.close = function() {
                    el.remove();
                    scope.$destroy();
                };

                function cancelTimeouts() {
                    if(promiseToDestroy) {
                        $timeout.cancel(promiseToDestroy);
                        promiseToDestroy = undefined;
                    }
                    $timeout.cancel(promiseToEnd);
                    el.addClass("show");
                }

                function startTimeouts() {
                    promiseToEnd = $timeout(function() {
                        el.removeClass("show");
                        promiseToDestroy = $timeout(scope.close, endingAnimationTime);
                    }, attr.time);
                }

                el.bind("mouseenter", cancelTimeouts);
                el.bind("mouseleave", startTimeouts);

                startTimeouts();
            }
        };
    })
    .directive('jvScrollModalContent', [function () {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                var _modalHeight = parseInt(attrs.jvScrollModalContent) || ($(window).height() - 150);
                elm.css("overflow","auto");
                elm.css("max-height", _modalHeight);
            }
        };
    }])
    .directive('jvSetFocus', ['$timeout', function ($timeout) {
        return {
            link: function(scope, element, attrs) {
                scope.$watch(attrs.jvSetFocus, function(value) {
                    if(value) {
                        if(attrs.jvSetButtons){
                            var buttonsDIV = $('#'+attrs.jvSetButtons);
                            if(buttonsDIV.length){
                                var inputOffset = $(element).offset();
                                buttonsDIV.css("position" ,"absolute");
                                buttonsDIV.css("background-color" ,"white");
                                buttonsDIV.css("left", inputOffset.left + $(element).width() - 200);
                                buttonsDIV.css("top", inputOffset.top + $(element).height() + 10);
                            }
                        }
                        $timeout(function() {
                            element.trigger('focus');
                        }, 0, false);
                    }
                });
            }
        };
    }]);
